import { render, staticRenderFns } from "./imgtextnavAttr.vue?vue&type=template&id=7bfbc6e4&scoped=true"
import script from "./imgtextnavAttr.vue?vue&type=script&lang=js"
export * from "./imgtextnavAttr.vue?vue&type=script&lang=js"
import style0 from "./imgtextnavAttr.vue?vue&type=style&index=0&id=7bfbc6e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfbc6e4",
  null
  
)

component.options.__file = "imgtextnavAttr.vue"
export default component.exports